<template>
  <div class="content">
    <img src="../assets/img/jyzx/jyzx.png" alt="" style="width: 100%;height: 320px;">
  <div style="width: 100%;display: flex;justify-content: center;background-color: rgba(0,2,13, 0.7);height: 437px;flex-wrap: wrap;">
 <div style="width: 100%;display: flex;justify-content: center;position: relative;">
  <div class="contentname">Trading center
    <div class="contentname1">交易中心</div>
  </div>

 </div>
 <div  class="tablist">
  <div class="tabss">
    <div :class="tabis==item?'tabsson':'tabssonother'" v-for="item,index in tablists" :key="index" @click="tabchange(item)">{{ item }}
      <div class="tabwl" v-if="tabis==item"></div>
    </div>
  </div>
 </div>
    <div class="tablelist">
      <el-table
      v-loading="loading"
      element-loading-text="拼命加载中"
    element-loading-background="rgba(0, 0, 0, 0.8)"
             empty-text="暂无数据"
             height="100%"
              :header-cell-style="{ backgroundColor: '#03091F', color: '#fff', fontSize: '16px', borderBottom: '1px #03091F solid' }"
              :cell-style="{ borderBottom: '1px #03091F solid',color:'#86A5C8' }"
              ref="gocarTable1"
              :data="tableData" tooltip-effect="dark" style="width: 100%;height: 240px;" @select="gocarlistset"
            :default-sort="{ prop: 'date', order: 'descending' }"
            :row-class-name="tableRowClassName"
            >

                 <el-table-column prop="name" :label="tabis=='项目需求'?'名称':''" show-overflow-tooltip align="center"> </el-table-column>
       
                 <el-table-column  :label="tabis=='项目需求'?'简介':''" align="center"  show-overflow-tooltip>
                <template #default="scope"><span v-text="scope.row.demandDescription" ></span></template>
              </el-table-column>
            </el-table>
            <!-- 信息总量 -->
            <div style="width: 100%;display: flex;justify-content: center;align-items: center;padding-top: 13px;">
              <div class="listnum"   v-if="listnum>0">共 {{ listnum }}条</div>
              <el-pagination
              v-if="listnum>0"
              style="margin-left: 20px;"
              :page-size="5"
            @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
  background
  layout="prev, pager, next"
  :total="listnum">
</el-pagination></div>
         
    </div>
  </div>
  

  </div>
  </template>
  
  <script>
  
  
  import { getAction } from '@/api/requests'
  
  export default {
    name: 'JyzxContent',
    components: {
  
     
    },
    props: {
          idsss: {
      type: String,
      default: '',
    },},
    data(){
      return{
        listnum:0,
        tableData:[],
        tablists:['项目需求','项目供给','成交公告','成果公示','资产交易','技术产权交易'],
        tabis:'项目需求',
        loading:false,
        dialogVisible:false
      }
    },
    watch: {
      idsss:{
      handler(val) {
   
        console.log(val);
        this.getzjsjlist()
      }
    },
    },
    mounted(){
      this.getzjsjlist()
    },
    methods:{
      handlecurrweipai(e){
  console.log(e);
},
// 表颜色
tableRowClassName({rowIndex}) {

  console.log(rowIndex);
        if (rowIndex%2 ==0) {
          return 'warning-row';
        } else  {
          return 'success-row';
        }
        // return '';
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
      },
      stripHtml(str = '') {
  return new DOMParser()
    .parseFromString(str, 'text/html')
    .body.textContent || '';
},
      getzjsjlist(e=1){
        this.loading = true
      let data = {
    
        pageNum:e,
pageSize:5
      }
      getAction("/edu/demand/list", data).then(res => {
        this.listnum = res.total
        this.tableData = res.rows
       this.tableData.forEach(element => {
        element.demandDescription =      this.stripHtml(element.demandDescription)
});       this.loading = false
        console.log(res)
     
      })
    },
      tabchange(item){
this.tabis = item
if(item=='项目需求'){
this.getzjsjlist()
}else{
  this.tableData = []
}

      }
    }
  }
  </script>
  
  <style scoped>
.content{
  width: 100%;
    height:calc( 100vh - 196px) ;
    background: #fff;
    background-image: url('../assets/img/jyzx/beij.png'); 
  background-size: cover;
  background-repeat: no-repeat; 
  background-position: center; 
}



::v-deep .el-table .warning-row {
    background: #000416;
  }

  /* ::v-deep  .el-tooltip__popper {
  max-width: 240px !important;
} */
  ::v-deep  .el-table .success-row {
    background: #01081E;
  }
  ::v-deep   .el-table__inner-wrapper:before{
    width: 0;

  }
  .tablelist{
    width: 1200px;
    height: 301px;
    background-color: #000618;
    cursor: pointer;
    margin-top: 16px;
  }
  .listnum{
    font-family: PingFang SC, PingFang SC;
font-weight: normal;
font-size: 14px;
color: #B9C5D1;
font-style: normal;
text-transform: none;
  }
  .contentname{
    display: flex;
    justify-content: center;
    width: 372px;
    font-family: Source Han Sans CN, Source Han Sans CN;
font-weight: 700;
font-size: 36px;
font-style: normal;
text-transform: none;
color: rgba(185,197,209, 0.1);
position: relative;
  }
  .contentname1{
    position: absolute;
    top: 35px;
    left: 133px;
    font-family: Source Han Sans, Source Han Sans;
font-weight: 400;
font-size: 24px;
color: #FFFFFF;
font-style: normal;
text-transform: none;
  }
  .tablist{
    width: 100%;
    justify-content: center;
    align-items: center;
    display: flex;
  }
  .tabss{
    width: 1200px;
    height: 48px;
margin-top: 22px;
display: flex;
justify-content: space-between;
cursor: pointer;
  }
  .tabsson{
    width: 180px;
height: 48px;
background: #165CE2;
border-radius: 4px 4px 4px 4px;
display: flex;
justify-content: center;
align-items: center;
font-family: Source Han Sans, Source Han Sans;
font-weight: 500;
font-size: 16px;
color: #FFFFFF;
font-style: normal;
text-transform: none;
position: relative;
  }
  .tabwl{
    position: absolute;
    width: 114px;
height: 2px;
background: linear-gradient( 90deg, rgba(22,92,226,0) 0%, #FFFFFF 48%, rgba(22,92,226,0) 100%);
border-radius: 4px 4px 4px 4px;
bottom: 1px;
left: 31px;
  }
  .tabssonother{
    width: 180px;
height: 48px;
background: #010A2A;
border-radius: 4px 4px 4px 4px;
display: flex;
justify-content: center;
align-items: center;
font-family: Source Han Sans, Source Han Sans;
font-weight: 400;
font-size: 16px;
color: #B9C5D1;
font-style: normal;
text-transform: none;
  }
/* //修改分页选中默认的背景色 */
:deep(.el-pagination.is-background .el-pager li:not(.is-disabled).is-active) {
  background-color: #165CE2 !important;
}

/* 未选中 */
::v-deep .el-pagination.is-background .el-pager li:not(.disabled) {
  background-color: #1A213A !important;
  color: #FFF !important;

}

::v-deep .el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager,
::v-deep .el-pagination.is-background .btn-next:disabled,
::v-deep .el-pagination.is-background .btn-prev,
::v-deep .el-pagination.is-background .btn-prev:disabled {
  background-color: #000618;
  color: #fff;
}
::v-deep  .el-table__body-wrapper{
  background-color: #000618;
}
  </style>
  
  